// components/ClientsCarousel.js
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

// Importe todas as imagens
import dantascontabil from '../../assets/clientes/dantascontabil.png';
import estadomaior from '../../assets/clientes/estadomaior.png';
import jmfood from '../../assets/clientes/jmfood.png';
import oquefazermaceio from '../../assets/clientes/oquefazermaceio.png';
import pipoca from '../../assets/clientes/pipoca.png';
import alugueja from '../../assets/clientes/alugueja.png';
import brandao from '../../assets/clientes/brandao.png';
import lojasintimos from '../../assets/clientes/lojasintimos.png';
import sgbov from '../../assets/clientes/sgbov.png';

const ClientsCarousel = () => {
  const clients = [
    { name: "Dantas Contábil", logo: dantascontabil },
    { name: "Estado Maior", logo: estadomaior },
    { name: "JM Food", logo: jmfood },
    { name: "O que fazer Maceio", logo: oquefazermaceio },
    { name: "Pipoca Gurmet", logo: pipoca },
    { name: "Alugueja", logo: alugueja },
    { name: "Brandão Imobiliária", logo: brandao },
    { name: "Lojas Íntimos", logo: lojasintimos },
    { name: "SGBov", logo: sgbov },
  ];

  return (
    <section id="clientes" className="py-24 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-4">
            Empresas que Escalam com a CriaApp
          </h2>
          <p className="text-gray-500 text-lg max-w-3xl mx-auto leading-relaxed font-light">
            Marcas que transformaram sua presença digital em aplicativos nativos de alto desempenho, aumentando engajamento, retenção e resultados através da plataforma CriaApp.
          </p>
        </div>

        <div className="relative">
          {/* Efeito de bordas com opacidade - Gradientes laterais */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white via-white/80 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white via-white/80 to-transparent z-10 pointer-events-none"></div>

          <Swiper
            modules={[Autoplay]}
            spaceBetween={60}
            slidesPerView={2}
            breakpoints={{
              480: {
                slidesPerView: 2,
                spaceBetween: 60
              },
              640: {
                slidesPerView: 3,
                spaceBetween: 70
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 80
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 90
              },
              1280: {
                slidesPerView: 6,
                spaceBetween: 100
              }
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            speed={1000}
            className="clients-swiper py-12"
          >
            {clients.map((client, index) => (
              <SwiperSlide key={index}>
                <div className="flex justify-center items-center group cursor-pointer">
                  <div className="p-4 transition-all duration-500 h-40 w-40 flex items-center justify-center relative">
                    <div className="h-24 w-24 rounded-2xl overflow-hidden flex items-center justify-center mix-blend-multiply">
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="h-full w-full object-contain grayscale opacity-40 contrast-125 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 ease-out drop-shadow-sm group-hover:drop-shadow-lg"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default ClientsCarousel;
